export enum OFFER_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ARCHIVE = 'archive',
  EXPIRED = 'expired',
}
